module.exports = __webpack_public_path__ + "static/media/Tapu Koko_gaussian2.6ce8352d.png";